var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGnbIco09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4C12.3281 4 13 4.67188 13 5.5V15.4902C11.8062 16.159 11 17.4377 11 18.9033C11 19.3064 11.1127 19.6813 11.3096 20H4.5C3.67188 20 3 19.3281 3 18.5V17H7.5C7.775 17 8 16.775 8 16.5C8 16.225 7.775 16 7.5 16H3V15H7.5C7.775 15 8 14.775 8 14.5C8 14.225 7.775 14 7.5 14H3V5.5C3 4.67188 3.67188 4 4.5 4H11.5ZM18.0908 16C19.6969 16.0001 20.9999 17.3031 21 18.9092C21 19.5123 20.5123 20 19.9092 20H13.0908C12.4877 20 12 19.5123 12 18.9092C12.0001 17.3031 13.3031 16.0001 14.9092 16H18.0908ZM16.5 10C17.163 10 17.7987 10.2636 18.2676 10.7324C18.7364 11.2013 19 11.837 19 12.5C19 13.163 18.7364 13.7987 18.2676 14.2676C17.7987 14.7364 17.163 15 16.5 15C15.837 15 15.2013 14.7364 14.7324 14.2676C14.2636 13.7987 14 13.163 14 12.5C14 11.837 14.2636 11.2013 14.7324 10.7324C15.2013 10.2636 15.837 10 16.5 10ZM7.4375 6C7.12578 6 6.875 6.25078 6.875 6.5625V7.875H5.5625C5.25078 7.875 5 8.12578 5 8.4375V9.5625C5 9.87422 5.25078 10.125 5.5625 10.125H6.875V11.4375C6.875 11.7492 7.12578 12 7.4375 12H8.5625C8.87422 12 9.125 11.7492 9.125 11.4375V10.125H10.4375C10.7492 10.125 11 9.87422 11 9.5625V8.4375C11 8.12578 10.7492 7.875 10.4375 7.875H9.125V6.5625C9.125 6.25078 8.87422 6 8.5625 6H7.4375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbIco09);
export default __webpack_public_path__ + "static/media/Gnb_ico_09.7536092d332a885f484c6d88134ff31a.svg";
export { ForwardRef as ReactComponent };